export default __webpack_public_path__ + "static/media/staking-green.52973050.mp4";